<script setup>
import ColorPicker from '../../../../components-next/colorpicker/ColorPicker.vue';

defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  ariaLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:modelValue']);
</script>

<template>
  <div
    class="w-full [&_.relative]:w-full [&_button]:min-h-11 [&_button]:w-full"
    @click.stop
  >
    <ColorPicker
      :model-value="modelValue"
      :aria-label="ariaLabel"
      class="!w-full"
      @update:model-value="color => emit('update:modelValue', color)"
    />
  </div>
</template>
